import { Config } from '@/config/types';

const developmentConfig: Config = {
  configType: 'development',
  apiRoot: 'https://7ajq1kzbn2.execute-api.ap-southeast-1.amazonaws.com',
  apiEmailRoot: 'https://api-uat.quiz.mynooci.com',
};

export default developmentConfig;
